import React, { useEffect, useState } from 'react'
import { useLocation,useNavigate } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from './Invoice';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import Layout from '../../Components/Layout';
import Voucher from '../Agency/Order/Voucher';

export default function Payment() {
    const [orderLoading, setOrderLoading] = useState(false); 
    const [orderData, setOrderData] = useState([]); 
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const location = useLocation(); 
    const data = location.state;
    const customer = location.state.guest;
    const agency = userData.user;
    const hotel = location.state.rate;
    const bookingId = location.state;


    console.log('location: ', location.state, 'userData: ', userData);
    console.log('total net: ', Number(orderData?.totalNet).toFixed(2))

    useEffect(() => {
        setOrderLoading(true);
        const fetchOrderDetails = async () => {
        try {
            const response = await axios.get(
            `${config.API_BASE_URL_V1}order/booking-detail/${bookingId}`,
            {
                headers: {
                Authorization: `Bearer ${userData.token}`,
                },
            }
            );
            setOrderData(response.data.data.booking);
            setOrderLoading(false);
        } catch (error) {
            console.error('Error fetching order details:', error);
            setOrderLoading(false);
        }
        };
        fetchOrderDetails();
    }, [bookingId, userData.token]);


    if(orderLoading)
    {
        return (
        <div id="loader-wrapper">
            <div id="loader">
                <span className="loader-line"></span>
            </div>
        </div>
        )
    }

    console.log('orderData: ',orderData)

  return (
    <Layout>
        <div class="breadcrumb-bar breadcrumb-bg-02 text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-12">
                    <h2 class="breadcrumb-title mb-2">Invoice</h2>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb justify-content-center mb-0">
                            <li class="breadcrumb-item"><a href="index.html"><i class="isax isax-home5"></i></a></li>
                            <li class="breadcrumb-item">Pages</li>
                            <li class="breadcrumb-item active" aria-current="page">Invoice</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="row justify-content-center">
            
                <div class="col-md-9">

                    <div className="d-flex flex-row gap-2 mb-4">

                    {orderData && Object.keys(orderData).length > 0 && (
                        <PDFDownloadLink
                            document={<Invoice orderData={orderData} />}
                            fileName="invoice.pdf"
                        >
                            {({ loading }) =>
                            loading ? (
                                <button className="btn btn-md btn-primary">Loading...</button>
                            ) : (
                                <button className="btn btn-md btn-primary">DMC Invoice</button>
                            )
                            }
                        </PDFDownloadLink>
                    )}

                    {orderData && Object.keys(orderData).length > 0 && (
                        <PDFDownloadLink document={<Voucher id={orderData?.reference} hotel={orderData?.hotelInfo} hotelDetail={orderData?.hotel} />} fileName="voucher.pdf">
                            {({ loading }) =>
                                loading ? (
                                <button className="btn btn-md btn-secondary">Loading...</button>
                                ) : (
                                <button className="btn btn-md btn-secondary">Voucher</button>
                                )
                            }
                        </PDFDownloadLink>
                    )}


                    </div>
                   
                    <div className="card mb-0 overflow-auto">
                        <div className="card-body px-md-5">
                            <div className="mb-4">
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-md-6"></div>
                                </div>
                            </div>

                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                                <div className="mb-4">
                                    <div className="row align-items-center g-4 mb-4">
                                        <div>
                                            <div className=" invoice-logo-dark">
                                                <img src="/assets/logo-1.png" className="img-fluid rounded-3" style={{ maxWidth: '200px', height: '50px', marginBlock:'30px' }} alt="logo-img" />
                                            </div>
                                            <h6 className="">Cornleth Travel & Booking System</h6>
                                            <p className="fs-14 mb-1">Email: <span className="text-gray-9">info@cornleth.com</span></p>
                                            <p className="fs-14 mb-1">Phone: <span className="text-gray-9">+90 212 533 31 22</span></p>
                                            <p className="fs-14 mb-1">Created Date: <span className="text-gray-9">{orderData?.creationDate}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-4 text-md-end text-center">
                                    <div className="mb-2 invoice-logo-dark">
                                        <div 
                                            // src={userData.user.profile_photo}
                                            className="img-fluid rounded-3"
                                            style={{ maxWidth: '200px', height: '100px' }}
                                        />
                                    </div>
                                    <h6 className="mb-1">{orderData?.holder?.name} {orderData?.holder?.surname}</h6>
                                    <p className="fs-14 mb-1">Reference: <span className="text-gray-9">{orderData?.clientReference}</span></p>
                                    <p className="fs-14 mb-1">Status: <span className="text-gray-9">{orderData?.status}</span></p>
                                    <p className="fs-14 mb-1">Invoice No: <span className="text-gray-9">#{orderData?.reference}</span></p>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table invoice-table text-center text-md-start">
                                    <thead className="thead-light">
                                        <tr>
                                            <th className="bg-light-400">Hotel</th>
                                            <th className="bg-light-400">Check-in</th>
                                            <th className="bg-light-400">Check-out</th>
                                            <th className="bg-light-400">Room Type</th>
                                            <th className="bg-light-400 text-end">Total Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData?.hotel?.rooms.map((room, index) => (
                                            <tr key={index}>
                                                <td>{orderData?.hotel?.name} ({orderData?.hotel?.categoryName})</td>
                                                <td>{new Date(orderData?.hotel?.checkIn).toLocaleDateString("en-GB")}</td>
                                                <td>{new Date(orderData?.hotel?.checkOut).toLocaleDateString("en-GB")}</td>
                                                <td className="text-end">{room.name} - {room.beds} Beds</td>
                                                <td className="text-end">{Number(orderData?.totalNet).toFixed(2)} {orderData?.currency}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row border-bottom mb-4">
                                <div className="col-md-5 mb-4 offset-md-7">
                                    <div className="d-flex justify-content-between border-bottom my-2 pe-3">
                                        <p className="fs-14 text-gray mb-0">Sub Total</p>
                                        <p className="text-gray-9 fs-14">{Number(orderData?.totalNet).toFixed(2)} {orderData?.currency}</p>
                                    </div>
                                    <div className="d-flex justify-content-between border-bottom my-2 pe-3">
                                        <p className="fs-14 text-gray mb-0">Pending Amount</p>
                                        <p className="text-gray-9 fs-14">{Number(orderData?.pendingAmount).toFixed(2)} {orderData?.currency}</p>
                                    </div>
                                    <div className="d-flex justify-content-between pe-3">
                                        <h6>Total Amount</h6>
                                        <h6>{Number(orderData?.totalNet).toFixed(2)} {orderData?.currency}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="text-center d-flex flex-column">
                                <p className="text-gray-9 fs-12 mb-1">Payable through {orderData?.hotel?.supplier?.name}, acting as agent for the service operating company, details of which can be provided upon request. VAT : {orderData?.hotel?.supplier?.vatNumber} Reference: {orderData?.reference}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    </Layout>
  )
}
